"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Sidebar/Desktop.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _user = require('shared/selectors/user');
var _peers = require('shared/selectors/peers');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _inbox = require('shared/hooks/inbox');

var _store = require('web/store');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _hooks = require('web/services/hooks');
var _persistor = require('web/services/persistor');
var _desktopShell = require('web/services/desktopShell');
var _FirstTimeTooltips = require('web/components/FirstTimeTooltips');
var _Avatar = require('web/components/Avatar');
var _WhatsNew = require('web/components/WhatsNew');

var _types = require('./types');
var _icons = require('./icons');
var _TitleTooltip = require('./TitleTooltip'); var _TitleTooltip2 = _interopRequireDefault(_TitleTooltip);
var _SettingsIcon = require('./SettingsIcon'); var _SettingsIcon2 = _interopRequireDefault(_SettingsIcon);


// Remembered per viewer, like the pending-users warning.
 const COLLAPSED_KEY = 'isSidebarCollapsed'; exports.COLLAPSED_KEY = COLLAPSED_KEY

const CollapsedContext = _react.createContext.call(void 0, false)

// Chats shows My Inbox's unread chats, as its Unread pill counts them.
const CHATS_COUNT_TABS = [_inbox.InboxTab.ALL] 
const useMyInboxUnreadCount = () => _nullishCoalesce(_optionalChain([_inbox.useInboxCounts.call(void 0, {
  teamKey: null,
  isArchived: false,
  canSeePatients: false,
  tabs: CHATS_COUNT_TABS,
}), 'optionalAccess', _ => _[_inbox.InboxTab.ALL], 'optionalAccess', _2 => _2.UnreadChats]), () => ( null))










/* A row of the expanded sidebar: icon, label and count. Collapsed, the label
 * shows as a tooltip instead, and a count as the unread dot. */
const NavItem = ({ title, iconName, onClick, isActive, hasBadge, count }) => {
  const isCollapsed = _react.useContext.call(void 0, CollapsedContext)
  const Icon = _icons.ROUTE_ICONS[iconName]
  const countText = count ? _inbox.formatPillCount.call(void 0, count) : null
  // Expanded, the number says it; until it loads (or if it fails), the dot.
  const hasDot = isCollapsed ? hasBadge || !!count : hasBadge && count == null
  return (
    _react2.default.createElement(_TitleTooltip2.default, { title: isCollapsed ? title : '', __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
      , _react2.default.createElement('button', {
        type: "button",
        className: _classBuilder2.default.call(void 0, 'blm-nav--item', isActive && 'is-on'),
        'aria-current': isActive ? 'location' : false,
        'aria-label': countText ? `${title}, ${countText} unread` : title,
        onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}

        , _react2.default.createElement('span', { className: "blm-nav--item--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
          , _react2.default.createElement(Icon, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 65}} )
          ,  hasDot && _react2.default.createElement('span', { className: "blm-nav--badge", __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}} ) 
        )
        , _react2.default.createElement('span', { className: "blm-nav--item--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}},  title )
        ,  countText && !isCollapsed && _react2.default.createElement('span', { className: "blm-nav--item--count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}},  countText ) 
      )
    )
  )
}

const normalizeBadgeCount = (n) => n > 9 ? '9+' : n

/* An icon-only button (Feedback, Settings), always with its tooltip. Takes
 * the rail icon's props so SettingsIcon can render it. */
const IconButton = ({
  title,
  iconName,
  onClick,
  isActive,
  hasBadge,
  badgeCount = 0,
  shouldHideTitleTooltip,
}) => {
  const isCollapsed = _react.useContext.call(void 0, CollapsedContext)
  const Icon = _icons.ROUTE_ICONS[iconName]
  return (
    _react2.default.createElement(_TitleTooltip2.default, { title: shouldHideTitleTooltip ? '' : title, place: isCollapsed ? 'right' : 'top', __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}
      , _react2.default.createElement('button', {
        type: "button",
        className: _classBuilder2.default.call(void 0, 'blm-nav--icon-btn', isActive && 'is-on'),
        'aria-current': isActive ? 'location' : false,
        'aria-label': title,
        onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}

        , _react2.default.createElement(Icon, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 99}} )
        ,  hasBadge && !badgeCount && _react2.default.createElement('span', { className: "blm-nav--badge", __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}} ) 
        ,  badgeCount > 0 && (
          _react2.default.createElement('span', { className: "blm-nav--badge blm-nav--badge-count" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}
            ,  normalizeBadgeCount(badgeCount) 
          )
        )
      )
    )
  )
}

const gotoProfile = () => _store.history.push('/settings/profile')

const makeUserName = (u) =>
  [_optionalChain([u, 'optionalAccess', _3 => _3.FirstName]), _optionalChain([u, 'optionalAccess', _4 => _4.LastName])].filter(Boolean).join(' ')

/* You: avatar, name and org, opening your profile. Collapsed, the avatar
 * alone. */
const Me = ({ userKey }) => {
  const isCollapsed = _react.useContext.call(void 0, CollapsedContext)
  const user = _hooks.useAppSelector.call(void 0, state => _peers.selectUserV2ByKey.call(void 0, state, userKey))
  const orgs = _hooks.useAppSelector.call(void 0, _user.selectMyActiveOrgsList)
  const orgLine = orgs.length > 1
    ? `${orgs[0].Name} +${orgs.length - 1}`
    : _optionalChain([orgs, 'access', _5 => _5[0], 'optionalAccess', _6 => _6.Name])
  return (
    _react2.default.createElement('div', { className: "blm-nav--me-wrap", __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}
      , _react2.default.createElement(_FirstTimeTooltips.WithProfileTooltip, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 127}}
      , _react2.default.createElement(_TitleTooltip2.default, { title: isCollapsed ? 'Your Profile' : '', __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}}
        , _react2.default.createElement('button', { type: "button", className: "blm-nav--me", 'aria-label': "Your Profile" , onClick: gotoProfile, __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}
          , _react2.default.createElement(_Avatar.UserAvatar, { size: 32, noOnlineIndicator: true, userKey: userKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 130}} )
          ,  !isCollapsed && (
            _react2.default.createElement('span', { className: "blm-nav--me--who", __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}}
              , _react2.default.createElement('span', { className: "blm-nav--me--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}},  makeUserName(user) )
              ,  orgLine && _react2.default.createElement('span', { className: "blm-nav--me--org", __self: this, __source: {fileName: _jsxFileName, lineNumber: 134}},  orgLine ) 
            )
          )
        )
      )
      )
    )
  )
}


















/* The desktop sidebar: the logo and a collapse toggle, the app's sections
 * and Feedback, and you with Settings at the foot. Collapsed, it is an icon
 * rail. Below the desktop breakpoint the mobile tab bar replaces it. */
const DesktopSidebar = ({
  myUserKey,
  activeRoute,
  hasInboxBadge,
  hasVideo,
  hasForms,
  hasSuperConsole,
  onFeedback,
  onGotoInbox,
  onGotoDirectory,
  onGotoCampaigns,
  onGotoForms,
  onGotoVideoRooms,
  onGotoSuperConsole,
}) => {
  const [isCollapsed, setIsCollapsed] = _react.useState(
    () => !!_persistor.getPersistedValue.call(void 0, myUserKey, exports.COLLAPSED_KEY),
  )
  const toggle = _react.useCallback.call(void 0, () => setIsCollapsed(was => {
    _persistor.persistValue.call(void 0, myUserKey, exports.COLLAPSED_KEY, !was)
    return !was
  }), [myUserKey])
  const toggleTitle = isCollapsed ? 'Show sidebar' : 'Hide sidebar'
  // The desktop app's traffic lights follow the sidebar's width.
  _react.useEffect.call(void 0, () => _optionalChain([window, 'access', _7 => _7.ELECTRON, 'optionalAccess', _8 => _8.setSidebarCollapsed, 'optionalCall', _9 => _9(isCollapsed)]), [isCollapsed])
  const chatsCount = useMyInboxUnreadCount()
  const isWindowsApp = _desktopShell.isWindowsDesktopApp.call(void 0, )
  const showsLogo = !isCollapsed && !isWindowsApp

  return (
    _react2.default.createElement(CollapsedContext.Provider, { value: isCollapsed, __self: this, __source: {fileName: _jsxFileName, lineNumber: 194}}
      , _react2.default.createElement('nav', { className: _classBuilder2.default.call(void 0, 'blm-nav', isCollapsed && 'blm-nav--collapsed'), 'aria-label': "App", __self: this, __source: {fileName: _jsxFileName, lineNumber: 195}}
        , _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'blm-nav--top', isWindowsApp && 'blm-nav--top-toggle-only'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 196}}
          /* The desktop app's traffic lights take the wordmark's place on
              macOS; on Windows its title bar names the app instead. */
          ,  _desktopShell.hasInsetTitleBar.call(void 0, )
            ? _react2.default.createElement('span', { className: "blm-nav--lights", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 200}} )
            : showsLogo && _react2.default.createElement('span', { className: "blm-nav--logo", role: "img", 'aria-label': "BloomText", __self: this, __source: {fileName: _jsxFileName, lineNumber: 201}} ) 
          , _react2.default.createElement(_TitleTooltip2.default, { title: toggleTitle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 202}}
            , _react2.default.createElement('button', {
              type: "button",
              className: "blm-nav--icon-btn",
              'aria-label': toggleTitle,
              'aria-expanded': !isCollapsed,
              onClick: toggle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 203}}

              , _react2.default.createElement(_icons.ToggleIcon, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 210}} )
            )
          )
        )
        ,  isCollapsed && _react2.default.createElement('div', { className: "blm-nav--separator", __self: this, __source: {fileName: _jsxFileName, lineNumber: 214}} ) 
        , _react2.default.createElement('div', { className: "blm-nav--items", __self: this, __source: {fileName: _jsxFileName, lineNumber: 215}}
          , _react2.default.createElement(NavItem, {
            title: "Chats",
            iconName: _types.RouteName.inbox,
            hasBadge: hasInboxBadge,
            count: chatsCount,
            isActive: activeRoute === _types.RouteName.inbox,
            onClick: onGotoInbox, __self: this, __source: {fileName: _jsxFileName, lineNumber: 216}}
          )
          , _react2.default.createElement(NavItem, {
            title: "Directory",
            iconName: _types.RouteName.directory,
            isActive: activeRoute === _types.RouteName.directory,
            onClick: onGotoDirectory, __self: this, __source: {fileName: _jsxFileName, lineNumber: 224}}
          )
          , _react2.default.createElement(NavItem, {
            title: "Campaigns",
            iconName: _types.RouteName.broadcast,
            isActive: activeRoute === _types.RouteName.broadcast,
            onClick: onGotoCampaigns, __self: this, __source: {fileName: _jsxFileName, lineNumber: 230}}
          )
          ,  hasForms && (
            _react2.default.createElement(NavItem, {
              title: "Forms",
              iconName: _types.RouteName.forms,
              isActive: activeRoute === _types.RouteName.forms,
              onClick: onGotoForms, __self: this, __source: {fileName: _jsxFileName, lineNumber: 237}}
            )
          )
          ,  hasVideo && (
            _react2.default.createElement(NavItem, {
              title: "Meetings",
              iconName: _types.RouteName.video,
              isActive: activeRoute === _types.RouteName.video,
              onClick: onGotoVideoRooms, __self: this, __source: {fileName: _jsxFileName, lineNumber: 245}}
            )
          )
          ,  hasSuperConsole && (
            _react2.default.createElement(NavItem, {
              title: "Superuser",
              iconName: _types.RouteName.super,
              isActive: activeRoute === _types.RouteName.super,
              onClick: onGotoSuperConsole, __self: this, __source: {fileName: _jsxFileName, lineNumber: 253}}
            )
          )
          , _react2.default.createElement(NavItem, {
            title: "Feedback",
            iconName: _types.RouteName.feedback,
            onClick: onFeedback, __self: this, __source: {fileName: _jsxFileName, lineNumber: 260}}
          )
        )
        , _react2.default.createElement(_WhatsNew.WhatsNewPill, { isCollapsed: isCollapsed, __self: this, __source: {fileName: _jsxFileName, lineNumber: 266}} )
        , _react2.default.createElement('div', { className: "blm-nav--foot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 267}}
          , _react2.default.createElement(Me, { userKey: myUserKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 268}} )
          , _react2.default.createElement('div', { className: "blm-nav--foot--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 269}}
            , _react2.default.createElement(_SettingsIcon2.default, {
              as: IconButton,
              title: "Settings",
              iconName: _types.RouteName.settings,
              isActive: activeRoute === _types.RouteName.settings,
              onClick: _actions2.default.gotoProfileSettings,
              tooltipPlace: isCollapsed ? 'right' : 'top', __self: this, __source: {fileName: _jsxFileName, lineNumber: 270}}
            )
          )
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, DesktopSidebar)
